import { Injectable } from '@angular/core';
import { PrismicService } from '@smarttask-common/src/lib/services/Integrations/Prismic/prismic.service';

@Injectable({
    providedIn: 'root',
})
export class ComparisonService {
    constructor(private prismicService: PrismicService) {}

    getDetails = (uid: string) => {
        const client = this.prismicService.getClient();

        return client
            .getByUID('comparison_v2', uid) // Fetch the document by UID
            .then((response: any) => {
                return response;
            });
    };
}
